/**
 *  @class
 *  @author WANG.J
 *  @function CompareTable
 */
if (!customElements.get('compare-table')) {
    class CompareTable extends HTMLElement {
      constructor() {
        super()
        const comparetable = this
        this.parent_section = comparetable.closest('.shopify-section')
        this.comparetable_tabs = Array.from(comparetable.querySelectorAll('.compare-table-tab li'))
        this.product_details = Array.from(comparetable.querySelectorAll('.tab-product-details .tab-product-detail'))
        this.product_details_fixed = Array.from(
          comparetable.querySelectorAll('.tab-product-detail-fixed .product-select')
        )
        this.comparetable_tab = comparetable.querySelector(".compare-table-tab")
        window.addEventListener('scroll', this.scroll.bind(this))
        window.dispatchEvent(new Event('scroll'))
        this.comparetable_tab.addEventListener('scroll', this.tabScroll.bind(this))
        this.comparetable_tab.dispatchEvent(new Event('scroll'))
  
         Array.from(comparetable.querySelectorAll('.product-shop .button')).forEach(btn => {
           btn.addEventListener('click',(event) => {
            this._onSubmit(event, btn.getAttribute('quick-controls'))
           })
         })



          this.querySelectorAll('a.product__zoom-button').forEach(function(elem){
            elem.addEventListener('click', function(){
              let txtContainer = document.querySelector('#lightbox .lb-container .lb-text');
              if(txtContainer != null){
                txtContainer.remove();
              }
            });
          })
      }
      tabScroll() {
        if(this.comparetable_tab.scrollLeft > 40){
          this.comparetable_tab.style.setProperty('--left',"40px")
        }else{
          this.comparetable_tab.style.setProperty('--left',"0px")
        }
        if(this.comparetable_tab.scrollWidth - this.comparetable_tab.offsetWidth - this.comparetable_tab.scrollLeft < 40){
          this.comparetable_tab.style.setProperty('--right',"0px")
        }else{
          this.comparetable_tab.style.setProperty('--right',"40px")
        }
      }
      scroll() {
        let headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10)
        let active = this.querySelector('.tab-content-item.active')
        if (window.scrollY - 250  > 0) {
          // active.querySelector('.fixed-content').style.display = 'block'
          // document.querySelector('.header-section').style.position = 'fixed'
          active.querySelector('.fixed-content').classList.add('fixed')
        } else {
          // active.querySelector('.fixed-content').style.display = 'none'
          // document.querySelector('.header-section').style.position = 'sticky'
          active.querySelector('.fixed-content').classList.remove('fixed')
        }
      }
      connectedCallback() {
        if (this.comparetable_tabs) {
          this.enableTab()
        }
        if (this.product_details) {
          this.enableSelect(this.product_details)
        }
        if (this.product_details_fixed) {
          this.enableSelect(this.product_details_fixed)
        }

        this.rowResizeObserver = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width
          if (width !== this.rowLayoutWidth) {
            this.rowLayoutWidth = width
            this.scheduleRowHeights()
          }
        })
        this.rowResizeObserver.observe(this)
        document.fonts.ready.then(() => {
          if (this.isConnected) this.scheduleRowHeights()
        })
        this.scheduleRowHeights()
      }
      disconnectedCallback() {
        this.rowResizeObserver?.disconnect()
        cancelAnimationFrame(this.rowHeightFrame)
      }
      scheduleRowHeights() {
        cancelAnimationFrame(this.rowHeightFrame)
        this.rowHeightFrame = requestAnimationFrame(() => this.syncRowHeights())
      }
      syncRowHeights() {
        this.querySelectorAll('.tab-content-item.active .tab-item-detail').forEach(detail => {
          const columns = Array.from(detail.querySelectorAll('.detail-inner-title'))
          columns.forEach(column => {
            column.querySelectorAll('li').forEach(item => item.style.height = 'auto')
          })
          const rows = columns
            .filter(column => column.getClientRects().length > 0)
            .map(column => Array.from(column.querySelectorAll('li')))
          const rowCount = Math.max(0, ...rows.map(items => items.length))
          const heights = Array.from({ length: rowCount }, (_, index) =>
            Math.ceil(Math.max(0, ...rows.map(items => items[index]?.getBoundingClientRect().height || 0)))
          )
          rows.forEach(items => {
            items.forEach((item, index) => item.style.height = `${heights[index]}px`)
          })
        })
      }
      enableSelect(details) {
        details.forEach((detail, index) => {
          let detailSelect = detail.querySelector('select')
          detailSelect.addEventListener('change', event => {
            const index = detailSelect.dataset.index
            const handle = detailSelect.options[detailSelect.options.selectedIndex].value
            const featuredImage = detailSelect.options[detailSelect.options.selectedIndex].dataset['featuredImage']
            const sizeImage = detailSelect.options[detailSelect.options.selectedIndex].dataset['sizeImage']
            const price = detailSelect.options[detailSelect.options.selectedIndex].dataset['price']
            const comparePrice = detailSelect.options[detailSelect.options.selectedIndex].dataset['comparePrice']
            const showCompare = detailSelect.options[detailSelect.options.selectedIndex].dataset['showCompare']
            const variantId = detailSelect.options[detailSelect.options.selectedIndex].dataset['variantId']
            const url = detailSelect.options[detailSelect.options.selectedIndex].dataset['url']
            const name = detailSelect.options[detailSelect.options.selectedIndex].text
            const contentItem = detailSelect.closest('.tab-content-item')
            contentItem
              .querySelectorAll('.tab-product-detail-fixed .product-select')
              [index].querySelector('select').options[detailSelect.options.selectedIndex].selected = true
            contentItem
              .querySelectorAll('.tab-product-details .tab-product-detail')
              [index].querySelector('select').options[detailSelect.options.selectedIndex].selected = true
            this.updateDetails.call(contentItem, index, handle)
            this.updateProductDetails.call(contentItem, index, handle, featuredImage, price,comparePrice,showCompare,  url, name,variantId,sizeImage)
            this.setDisableSelect.call(contentItem,index, handle)
            this.scheduleRowHeights()
          })
          detailSelect.dispatchEvent(new Event('change'))
        })
      }
      enableTab() {
        let tabs = this.comparetable_tabs
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', event => {
            let handle = tab.dataset.index
            ;[].forEach.call(tabs, function (el) {
              el.classList.remove('active')
            })
            tab.classList.add('active')
            this.comparetable_tab.scrollTo({
              left: (tab.offsetLeft + tab.clientWidth / 2) - document.body.clientWidth / 2,
              behavior: "smooth"
            });
            
            if (handle) {
              this.toggleTab(handle)
            }
            event.preventDefault()
          })
        })

        let tabSelect = this.querySelector('.compare-table-tab-select select')
        if(tabSelect){
            tabSelect.addEventListener('change', event => {
                const handle = tabSelect.options[tabSelect.options.selectedIndex].value
                if (handle) {
                    this.toggleTab(handle)
                }
            })
        }

        
        let collectionSelects = this.querySelectorAll('.params-title-select select')
        collectionSelects.forEach(collectionSelect => {
            collectionSelect.addEventListener('change', event => {
                const handle = collectionSelect.options[collectionSelect.options.selectedIndex].value
                if (handle) {
                  collectionSelects.forEach(item => {
                    if(item != collectionSelect){
                      item.options[collectionSelect.options.selectedIndex].selected = true
                    }
                  })
                  this.toggleTab(handle)
                }
            })
        })
      }
      setDisableSelect(index,handle){
        let details = this.querySelectorAll('.tab-product-details .tab-product-detail');
        let selectedValues = []
        details.forEach((detail,i) => {
          if(window.getComputedStyle(detail).display != "none"){
            let detailSelect = detail.querySelector('select')
            selectedValues.push(detailSelect.options[detailSelect.options.selectedIndex].value)
          }
        });
        let details1 = this.querySelectorAll('.tab-product-detail-fixed .product-select')
  
        
        details.forEach((detail,i) => {
          let detailSelect = detail.querySelector('select')
          const selectValue = detailSelect.options[detailSelect.options.selectedIndex].value;
          let thisSelected = []
          Object.assign(thisSelected,selectedValues)
          ;[].forEach.call(detail.querySelectorAll("option[disabled=true]"), function (el) {
            el.removeAttribute("disabled")
          });
           ;[].forEach.call(thisSelected,function(item){
             if(item != selectValue){
              detail.querySelector("option[value='"+item+"']").setAttribute("disabled",true);
             }
          });
        });
        details1.forEach((detail,i) => {
          let detailSelect = detail.querySelector('select')
          const selectValue = detailSelect.options[detailSelect.options.selectedIndex].value;
          let thisSelected = []
          Object.assign(thisSelected,selectedValues)
          ;[].forEach.call(detail.querySelectorAll("option[disabled=true]"), function (el) {
            el.removeAttribute("disabled")
          });
           ;[].forEach.call(thisSelected,function(item){
             if(item != selectValue){
              detail.querySelector("option[value='"+item+"']").setAttribute("disabled",true);
             }
          });
        });
      }
      toggleTab(handle) {
        let tabs = this.querySelectorAll(`.tab-content-item:not([data-index*="${handle}"])`),
          active_tabs = this.querySelectorAll(`[data-index*="${handle}"]`)
        ;[].forEach.call(tabs, function (el) {
          el.classList.remove('active')
        })
        ;[].forEach.call(active_tabs, function (el) {
          el.classList.add('active')
        })
        this.scroll()
        this.scheduleRowHeights()
      }
      updateProductDetails(index, handle, featuredImage, price,comparePrice,showCompare, url, name,variantId,sizeImage) {
        
        const productDetail = this.querySelectorAll('.tab-product-details .tab-product-detail')[index]
        const itemProductDetail = this.querySelectorAll('.tab-item-product-detail .tab-product-detail')[index]
        if(handle == -1){
          productDetail.querySelector('.product-name').classList.add("hidden")
          productDetail.querySelector('.product-price').classList.add("hidden")
          productDetail.querySelector('.product-shop').classList.add("hidden")
          productDetail.querySelector('.product-more').classList.add("hidden")
          productDetail.querySelector('.product-image').classList.add("hidden")
          if(itemProductDetail){
          itemProductDetail.querySelector('.product-name').classList.add("hidden")
          itemProductDetail.querySelector('.product-price').classList.add("hidden")
          itemProductDetail.querySelector('.product-shop').classList.add("hidden")
          itemProductDetail.querySelector('.product-more').classList.add("hidden")
          itemProductDetail.querySelector('.product-image').classList.add("hidden")
          }
          return
        }else{
          productDetail.querySelector('.product-name').classList.remove("hidden")
          productDetail.querySelector('.product-price').classList.remove("hidden")
          productDetail.querySelector('.product-shop').classList.remove("hidden")
          productDetail.querySelector('.product-more').classList.remove("hidden")
          productDetail.querySelector('.product-image').classList.remove("hidden")
          if(itemProductDetail){
          itemProductDetail.querySelector('.product-name').classList.remove("hidden")
          itemProductDetail.querySelector('.product-price').classList.remove("hidden")
          itemProductDetail.querySelector('.product-shop').classList.remove("hidden")
          itemProductDetail.querySelector('.product-more').classList.remove("hidden")
          itemProductDetail.querySelector('.product-image').classList.remove("hidden")
          }
        }
        if(!variantId){
          productDetail.querySelector('.product-shop .button').innerText ="SOLDOUT"
          productDetail.querySelector('.product-shop .button').setAttribute('disabled', "disabled")
          if(itemProductDetail){
          itemProductDetail.querySelector('.product-shop .button').innerText ="SOLDOUT"
          itemProductDetail.querySelector('.product-shop .button').setAttribute('disabled', "disabled")
          }
        }else{
          productDetail.querySelector('.product-shop .button').removeAttribute('disabled')
          productDetail.querySelector('.product-shop .button').innerText ="ADD TO CART"
          if(itemProductDetail){
          itemProductDetail.querySelector('.product-shop .button').removeAttribute('disabled')
          itemProductDetail.querySelector('.product-shop .button').innerText ="ADD TO CART"
          }
        }
        
        productDetail.querySelector('.product-name').innerText = name
        productDetail.querySelector('.product-price').innerHTML = ""
        if(showCompare != "true"){
          productDetail.querySelector('.product-price').innerText = price
        }else{
          productDetail.querySelector('.product-price').innerHTML = "<span class='price'>"+price+"</span><span class='compare-price'>"+comparePrice+"</span>"
        }
        productDetail.querySelector('.product-more a').href = url
        productDetail.querySelector('.product-image img').src = featuredImage
        productDetail.querySelector('.product-image a').href = sizeImage
        productDetail.querySelector('.product-image a').dataset.lightbox = handle
        productDetail.querySelector('.product-shop .button').setAttribute('quick-controls', variantId)
        
        if(itemProductDetail){
        itemProductDetail.querySelector('.product-name').innerText = name
        itemProductDetail.querySelector('.product-price').innerHTML = ""
        if(showCompare != "true"){
          itemProductDetail.querySelector('.product-price').innerText = price
        }else{
          itemProductDetail.querySelector('.product-price').innerHTML = "<span class='price'>"+price+"</span><span class='compare-price'>"+comparePrice+"</span>"
        }
        itemProductDetail.querySelector('.product-more a').href = url
        itemProductDetail.querySelector('.product-image img').src = featuredImage
        itemProductDetail.querySelector('.product-image a').href = sizeImage
        itemProductDetail.querySelector('.product-image a').dataset.lightbox = handle
        itemProductDetail.querySelector('.product-shop .button').setAttribute('quick-controls', variantId)
        }
        
      }
      updateDetails(index, handle) {
        if(handle == -1){
          this.querySelectorAll(".tab-item-detail").forEach(itemDetail => {
            const inner = itemDetail.querySelectorAll('.tab-item-detail-content .tab-item-detail-content-inner')[index]
            inner.querySelectorAll('.des').forEach(des => {
              des.classList.add("hidden")
            })
          })
          return
        }else{
          this.querySelectorAll(".tab-item-detail").forEach(itemDetail => {
            const inner = this.querySelectorAll('.tab-item-detail-content .tab-item-detail-content-inner')[index]
            inner.querySelectorAll('.des').forEach(des => {
              des.classList.remove("hidden")
            })
          })
        }
        let specificationStr = this.querySelector('#specification-' + handle).textContent.trim()
        if (specificationStr) {
          let specifications = JSON.parse(specificationStr)
          let specMap = {}
          specifications.forEach(specification => {
            const specificationArr = specification.split(' -- ')
            const specificationArr2 = specificationArr[2] ? specificationArr[2] : 'N.A.'
            const specificationArr2s = specificationArr2.split("Yes");
            const yesIcon = '<span class="yes-icon"></span>';
            let html = ""
            if(specificationArr2.startsWith("Yes")){
              html += yesIcon
            }
            specificationArr2s.forEach((item,index) => {
              if(item){
                const item_html = item.replace("|","<br>");
                html += `<span>${item_html}</span>`
                if(index+1 != specificationArr2s.length){
                  html += yesIcon
                }
              }
            })

            if(specificationArr2.endsWith("Yes") && specificationArr2 != "Yes"){
              html += yesIcon
            }


            
            let specTitleHtml = `<li><div class="title">${specificationArr[1]}</div></li>`
            let specLiHtml = `<li><div class="title">${specificationArr[1]}</div><div class="des">${html}</div></li>`
            if (specificationArr[0]) {
              if (specMap[specificationArr[0].toLowerCase()]) {
                specMap[specificationArr[0].toLowerCase()+"_params-title"] = specMap[specificationArr[0].toLowerCase()+"_params-title"] + specTitleHtml
                specMap[specificationArr[0].toLowerCase()] = specMap[specificationArr[0].toLowerCase()] + specLiHtml
              } else {
                specMap[specificationArr[0].toLowerCase()+"_params-title"] = specTitleHtml
                specMap[specificationArr[0].toLowerCase()] = specLiHtml
              }
            }
          })
  
          Object.keys(specMap).forEach(key => {
            if(key.indexOf("_params-title") > -1){
              const parameterName = key.replace("_params-title", "");
              const itemDetail = this.querySelector(`[parameter-name*="${parameterName}"]`)
              if(itemDetail){
                itemDetail.querySelector('.tab-item-detail-content .params-title .detail-inner-title').innerHTML = specMap[key]
              }
            }else{
              const itemDetail = this.querySelector(`[parameter-name*="${key}"]`)
              if (itemDetail) {
                const inner = itemDetail.querySelectorAll('.tab-item-detail-content .tab-item-detail-content-inner')[index]
                inner.querySelector('.detail-inner-title').innerHTML = specMap[key]
              }
            }
          })
        }
      }

      async _onSubmit(event,variantId) {
        const submitBtn = event.target;
        event.preventDefault();
        if(!submitBtn.getAttribute("disabled")){
          submitBtn.setAttribute("disabled", "disabled");
          const productForm = new FormData();
          productForm.append("sections", ["mini-cart"]);
          productForm.append("quantity", 1);
          productForm.append("id", variantId);

          const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            body: productForm,
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            }
          });
          submitBtn.removeAttribute("disabled");
        
          const responseJson = await response.json();
          if (response.ok) {
            this.dispatchEvent(new CustomEvent("variant:added", {
              bubbles: true,
              detail: {
                variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
              }
            }));
            fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
              const cartContent = await response2.json();
              document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                bubbles: true,
                detail: {
                  cart: cartContent
                }
              }));
              cartContent["sections"] = responseJson["sections"];
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cartContent,
                  openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
                }
              }));
            });
          }
          this.dispatchEvent(new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: {
              status: response.ok ? "success" : "error",
              error: responseJson["description"] || ""
            }
          }));
        }
      }
    }
    customElements.define('compare-table', CompareTable)
  }
